import axios from 'axios'
import { ref } from 'vue'

export function useSurveys({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteSurvey = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/surveys/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteSurvey,
    }
}
